export function Profile() {
  return (
    <span>
      <h1>Will Boluyt</h1>
      <hr />
      <br />
      <p>Testing...</p>
    </span>
  );
}
